import { api, Core } from "@ancademy/vse-client";
import { PageSize } from "@ancademy/vse-share";
import { css } from "@emotion/css";
import { IMainPlayerState } from "@share";
import { subViewList } from "@sub";
import { Button, Checkbox, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import { ICreateParams, IGameState, IMoveParams, IPlayerState, IPushParams, MoveType, PushType } from "../config";

export function Play4Owner({
  game,
}: Core.IPlay4OwnerProps<ICreateParams, IGameState, IPlayerState, MoveType, PushType, IMoveParams, IPushParams>) {
  const PAGE_SIZE = PageSize.default;
  const [loading, setLoading] = useState(false),
    [page, setPage] = useState(0),
    [count, setCount] = useState(0),
    [list, setList] = useState([] as any[]);
  const fetchPage = async (page: number = 0) => {
    setLoading(true);
    const data = await api.getState4OwnerList(game.id, PAGE_SIZE, page);
    setLoading(false);
    setPage(page);
    setCount(data.count);
    setList(data.list);
  };

  useEffect(() => {
    fetchPage().then();
  }, []);
  return (
    <>
      <Table
        dataSource={list}
        loading={loading}
        size="small"
        rowKey="id"
        pagination={{
          pageSize: PAGE_SIZE,
          current: page + 1,
          total: count,
        }}
        onChange={({ current }) => fetchPage(current - 1)}
      >
        <Table.Column title="姓名" dataIndex="stuName" />
        <Table.Column title="学号" dataIndex="stuNum" />
        <Table.Column
          title="进度"
          dataIndex="data"
          render={({ subGameList }: IMainPlayerState) => (
            <Space>
              {subGameList
                .filter((s) => s.r === 0)
                .map(({ namespace, over }) => (
                  <Checkbox key={namespace} checked={over}>
                    {subViewList.find((s) => s.namespace === namespace).label}
                  </Checkbox>
                ))}
            </Space>
          )}
        />
      </Table>
      <div
        className={css`
          display: flex;
          justify-content: center;
        `}
      >
        <Button type="primary" loading={loading} onClick={() => fetchPage()}>
          &nbsp;&nbsp;刷&nbsp;新&nbsp;&nbsp;
        </Button>
      </div>
    </>
  );
}
